import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { Typography, Box } from '@material-ui/core'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import MinimizeRoundedIcon from '@material-ui/icons/MinimizeRounded'

import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Wallet } from '../../types/wallet'
import { Proforma } from '../../types/walletProforma'
import useStyles from './styles/SummeryOfPayment.styles'

interface SummeryOfPaymentProps {
  proforma: Proforma
  wallet: Wallet
  creditorName?: string
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      proforma: Proforma
    }>
  >
}

const SummeryOfPayment: React.FC<SummeryOfPaymentProps> = ({
  proforma,
  wallet,
  creditorName
}) => {
  const classes = useStyles()

  const totalAmount = proforma?.transactions.reduce(
    (sum, transaction) => sum + transaction.amount,
    0
  )

  return (
    <div>
      {' '}
      <SectionTitle title="Summary of Payment" marginBottom />
      <div className={classes.root}>
        <div className={classes.sectionRow}>
          <Typography variant="body2">
            <MinimizeRoundedIcon />

            {getTranslate('Wallet Entity')}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {wallet.entity.entityType + ' - ' + wallet.entity.entityName}
          </Typography>
        </div>
        <div className={classes.sectionRow}>
          <Typography variant="body2">
            {' '}
            <MinimizeRoundedIcon />
            {getTranslate('Wallet Type')}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {wallet.walletType}
          </Typography>
        </div>

        {wallet.isBilateral && creditorName && (
          <div className={classes.sectionRow}>
            <Typography variant="body2">
              {' '}
              <MinimizeRoundedIcon />
              {getTranslate('Creditor')}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {creditorName}
            </Typography>
          </div>
        )}

        <Box className={classes.paymentBox}>
          <div className={classes.paymentRow}>
            <Box display="flex" alignItems="center">
              <AttachMoneyIcon fontSize="small" className={classes.icon} />
              <Typography variant="body2">
                {getTranslate('Total Payment')}
              </Typography>
            </Box>
            <Typography variant="body2">
              {totalAmount + ' ' + wallet.currency}
            </Typography>
          </div>
        </Box>
      </div>
    </div>
  )
}

export default SummeryOfPayment
